import { Component, Input, Output, ViewChild, EventEmitter, ElementRef, ChangeDetectionStrategy } from '@angular/core'
import { ModalDirective } from 'ngx-bootstrap/modal'

@Component({
  selector: 'modal-container',
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalContainerComponent {
  @ViewChild('childModal') public childModal: ModalDirective
  @ViewChild('modalRoot') public modalRoot!: ElementRef<HTMLDivElement>
  @Output() hide: EventEmitter<any> = new EventEmitter()

  @Input() public headerIconClass: string
  @Input() public headerTitle: string
  @Input() public headerTitleAfterTranslatedTitle: string
  @Input() public modalHeaderBgColorClass: string
  @Input() public modalBodyBgColorClass: string
  @Input() public modalFooterBgColorClass: string
  @Input() public translateTitle = true
  @Input() public hasBackdrop = true
  @Input() public ignoreBackdropClick = false
  @Input() public noPaddingModalBody = false
  @Input() public isSmallModal = false
  @Input() public isLargeModal = false
  @Input() public isExtraLargeModal = false
  @Input() public isModalFromRight = false
  @Input() public isModalFromLeft = false
  @Input() public isFullWidth = false
  @Input() public isModalInModal = false
  @Input() public isLoading = false
  @Input() public isHideBtnHidden = false
  @Input() public isModalForProductChoose = false
  @Input() public hideCloseButton = false

  private lastActiveElement: HTMLElement | null = null

  public showChildModal(): void {
    // Remember the element that triggered the modal to restore focus later
    this.lastActiveElement = (document.activeElement as HTMLElement) ?? null
    this.childModal.show()
    // After the modal is shown, move focus to the dialog container for a11y
    setTimeout(() => {
      try {
        const root = this.modalRoot?.nativeElement
        root?.focus?.()
      } catch {}
    })
  }

  public hideChildModal(emitHideEvent = true): void {
    // If a focused element remains inside the modal, blur it before hiding
    try {
      const active = document.activeElement as HTMLElement | null
      const root = this.modalRoot?.nativeElement
      if (active && root && root.contains(active)) {
        active.blur()
      }
    } catch {}
    if (emitHideEvent) this.hide.emit(null)
    this.childModal.hide()
    // Restore focus to the previously active element (if still in the DOM and focusable)
    setTimeout(() => {
      try {
        if (this.lastActiveElement && document.contains(this.lastActiveElement)) {
          this.lastActiveElement.focus()
        }
      } catch {}
      this.lastActiveElement = null
    })
  }

  public isShown(): boolean {
    return this.childModal.isShown
  }
}
